// extracted by mini-css-extract-plugin
export var audioPlayer = "_qy-0";